export default defineNuxtPlugin((_nuxtApp) => {
  const router = useRouter()
  const general = useGeneralStore()
  // Set general.isMobileMenuOpen to false in every route change
  router.afterEach(() => {
    general.setMobileSidebarOpen(false)
  })
})
